import React from "react";

function ClockIcon({ style={} }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...style}>
            <g clipPath="url(#clip0_2583_20225)">
                <path
                    d="M8.13782 7.05969L6.46469 5.80484V3.2487C6.46469 2.99169 6.25694 2.78394 5.99992 2.78394C5.74291 2.78394 5.53516 2.99169 5.53516 3.2487V6.03725C5.53516 6.18364 5.60395 6.32169 5.72106 6.40906L7.58008 7.80333C7.66031 7.86375 7.75803 7.89638 7.85847 7.89629C8.00022 7.89629 8.13965 7.83261 8.23075 7.70991C8.38509 7.50493 8.34325 7.21353 8.13782 7.05969Z"
                    fill="currentColor"
                />
                <path
                    d="M6 0C2.6914 0 0 2.6914 0 6C0 9.3086 2.6914 12 6 12C9.3086 12 12 9.3086 12 6C12 2.6914 9.3086 0 6 0ZM6 11.0705C3.20449 11.0705 0.929508 8.79551 0.929508 6C0.929508 3.20449 3.20449 0.929508 6 0.929508C8.79598 0.929508 11.0705 3.20449 11.0705 6C11.0705 8.79551 8.79551 11.0705 6 11.0705Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2583_20225">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default ClockIcon;
